import type { ComponentProps } from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { tv } from "tailwind-variants";

const radioGroupVariants = tv({
  slots: {
    root: "grid gap-3",
    item: [
      "aspect-square size-4.5 shrink-0 cursor-pointer rounded-full border shadow-raised",
      "border-line-control bg-surface",
      "transition-[background-color,border-color,box-shadow] duration-150",
      "hover:border-content-subtle",
      "focus:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:ring-offset-canvas focus-visible:outline-none",
      "data-[state=checked]:border-accent data-[state=checked]:bg-accent",
      "disabled:cursor-not-allowed disabled:border-line-strong disabled:bg-surface-sunken disabled:opacity-60",
      "data-[state=checked]:disabled:border-line-strong data-[state=checked]:disabled:bg-line-strong",
    ],
    indicatorWrapper: "relative flex size-full items-center justify-center",
    indicator: "size-1.75 rounded-full bg-content-on-accent",
  },
});

const { indicator, indicatorWrapper, item, root } = radioGroupVariants();

const Root = ({ className, ...props }: ComponentProps<typeof RadioGroupPrimitive.Root>) => {
  return (
    <RadioGroupPrimitive.Root className={root({ className })} data-slot="radio-group" {...props} />
  );
};

const Indicator = ({
  className,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Indicator>) => {
  return (
    <RadioGroupPrimitive.Indicator
      className={indicatorWrapper({ className })}
      data-slot="radio-group-indicator"
      {...props}
    >
      <div className={indicator()} />
    </RadioGroupPrimitive.Indicator>
  );
};

const Item = ({ className, ...props }: ComponentProps<typeof RadioGroupPrimitive.Item>) => {
  return (
    <RadioGroupPrimitive.Item
      className={item({ className })}
      data-slot="radio-group-item"
      {...props}
    />
  );
};

export const RadioGroup = { Root, Item, Indicator };
